// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"92":"322d3de0","139":"ba9eb7f2","470":"99c6368e","607":"bd695813","760":"b81f35ac","798":"c6bf7c57"}[chunkId] + ".chunk.js";
};